import { render, staticRenderFns } from "./VisualizarProcessosPorGOModal.vue?vue&type=template&id=987ef18e&scoped=true&lang=pug"
import script from "./VisualizarProcessosPorGOModal.vue?vue&type=script&lang=js"
export * from "./VisualizarProcessosPorGOModal.vue?vue&type=script&lang=js"
import style0 from "./VisualizarProcessosPorGOModal.vue?vue&type=style&index=0&id=987ef18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987ef18e",
  null
  
)

export default component.exports